import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function PlaneSendIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M7.167 8H3.682m-.054.188-1.48 4.477c-.116.351-.174.527-.132.636a.32.32 0 0 0 .21.192c.11.031.277-.045.611-.197l10.59-4.827c.327-.149.49-.223.54-.326a.33.33 0 0 0 0-.285c-.05-.103-.213-.177-.54-.326L2.835 2.703c-.333-.151-.5-.227-.61-.196a.32.32 0 0 0-.21.192c-.042.108.015.283.13.634l1.485 4.53c.02.06.03.09.033.121a.3.3 0 0 1 0 .082 1 1 0 0 1-.034.122" /></svg>
  );
}

export default PlaneSendIcon;
